import { IIAMEntity } from "./iam-entity";
import { IIAMUserRequest } from "./iam-users";

export interface IIAMGroup extends IIAMEntity {
  GroupName?: string;
  GroupId?: string;
}

export interface IIAMGroupRequest {
  GroupName: string;
}

export interface IIAMGroupUpdateRequest extends IIAMGroupRequest {
  NewGroupName: string;
}
export interface IIAMGroupUserRequest
  extends IIAMGroupRequest,
    IIAMUserRequest {}

export interface IIAMGroupPolicyRequest extends IIAMGroupRequest {
  PolicyArn: string;
}

export enum IAMGroupSortField {
    GroupName = "GroupName",
    ARN = "Arn",
    CreateDate = "CreateDate",
}